import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtText from "../../../components/NtText";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtTelehealthPartnerSection({}) {
  const isMobile = useMobile();

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View
        style={{
          width: "100%",
        }}
      >
        <NtSectionTitle>
          VOXCRAFT IS A CERTIFIED PARTNER OF TRITAN SOFTWARE
        </NtSectionTitle>

        <View
          style={{
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 30,
            marginBottom: 30,
          }}
        >
          <Image
            style={[
              {
                width: 200,
                height: 80,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/37c7adc277610644955e18f2bca3589921626286.png")}
          />
        </View>

        <NtSectionDescription style={{ textAlign: "center" }}>
          The world is also filled with compliance regulations from health
          authorities, such as the Center for Disease Control (CDC), WHO, CLIA,
          EU Healthy Gateways, Robert-Koch-Institute, and the cruise line Flag &
          Government Regulators. The Tritan Software SeaCare platform ensures
          these requirements are adhered to. The SeaCare platform can receive,
          process, monitor, protect, and manage the required health data of each
          person onboard (guests and crew), all of which are provided through
          the ongoing contactless health-check methods gathered and made
          available through VOXCRAFT.
        </NtSectionDescription>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
    alignItems: "center",
  },
});

export default NtTelehealthPartnerSection;
